export const isDevEnvironment = typeof process !== "undefined" ? process?.env?.NODE_ENV !== "production" : false;
